<div class="flex h-[30rem] flex-col gap-3">

  <!-- Fil de la conversation -->
  <div #thread (scroll)="onThreadScroll()"
       aria-live="polite"
       class="soft-scrollbar flex min-h-0 flex-1 flex-col gap-3 overflow-y-auto pr-2"
       role="log">

    <!-- Le chat interroge tous les todos accessibles : on l'annonce avant la première question -->
    <div class="max-w-[85%] self-start rounded-lg bg-[var(--p-surface-100)] px-3 py-2 text-sm">
      {{ 'ai.intro' | translate }}
    </div>

    @for (message of messages(); track message.id) {
      @if (message.action) {
        <div class="max-w-[85%] self-start">
          <elcia-ai-action-card (cancelled)="cancel($event)"
                                (confirmed)="confirm($event)"
                                [isBusy]="isResolvingAction()"
                                [message]="message"/>
        </div>
      } @else if (message.role === userRole) {
        <div class="max-w-[85%] self-end whitespace-pre-line rounded-lg bg-primary-500 px-3 py-2 text-sm text-white">
          {{ message.content }}
        </div>
      } @else {
        <!-- Le modèle répond en markdown : sans rendu, l'utilisateur lit les astérisques et les tirets -->
        <div [innerHTML]="message.content | aiMarkdown"
             class="max-w-[85%] self-start rounded-lg bg-[var(--p-surface-100)] px-3 py-2 text-sm"></div>
      }
    }

    @if (pendingMention(); as mention) {
      <div class="max-w-[85%] self-start">
        <elcia-ai-name-picker (chosen)="choose($event)" [mention]="mention"/>
      </div>
    }

    <!-- Étapes poussées par /hubs/ai : on voit ce que l'assistant consulte pendant qu'il cherche -->
    @if (isThinking()) {
      <div class="flex flex-col gap-1 self-start" role="status">
        @for (step of steps(); track $index) {
          <span class="flex items-center gap-1.5 text-xs text-surface-500">
            <span aria-hidden="true" class="pi pi-check text-primary-400" style="font-size: 0.625rem"></span>
            {{ 'ai.step.' + step | translate }}
          </span>
        }
        <span class="text-sm italic text-surface-400">{{ 'ai.thinking' | translate }}</span>
      </div>
    }

    @if (hasFailed()) {
      <div class="flex items-center gap-2 self-start" role="status">
        <span class="text-sm italic text-orange-600">{{ 'ai.chat-failed' | translate }}</span>
        <!-- La question est conservée : on la rejoue sans la faire retaper -->
        <elcia-button (onClick)="retry()"
                      [disabled]="isBusy()"
                      [icon]="'sync'"
                      [label]="'action.retry' | translate"
                      [severity]="'secondary'"
                      [size]="'small'"
                      [variant]="'text'"/>
      </div>
    }
  </div>

  @if (isMicUnavailable()) {
    <span class="text-xs italic text-orange-600" role="status">{{ 'ai.mic-unavailable' | translate }}</span>
  }

  @if (hasDictationFailed()) {
    <span class="text-xs italic text-orange-600" role="status">{{ 'ai.dictation-failed' | translate }}</span>
  }

  @if (isRecording()) {
    <span class="flex items-center gap-1.5 text-xs text-red-600" role="status">
      <span aria-hidden="true" class="pi pi-circle-fill" style="font-size: 0.5rem"></span>
      {{ 'ai.recording' | translate }} {{ elapsedLabel() }}
    </span>
  }

  <!-- Saisie -->
  <div class="flex items-center gap-2">
    <!-- Entrée n'envoie que depuis le champ : sur un bouton focalisé, elle déclencherait aussi son clic -->
    <div (keydown.enter)="send()" class="flex-1">
      <elcia-text-input [control]="draft" [label]="'ai.placeholder' | translate"/>
    </div>
    <!-- La dictée remplit le champ, elle n'envoie pas : on relit avant d'envoyer -->
    <elcia-button (onClick)="toggleRecording()"
                  [disabled]="isThinking() || isTranscribing()"
                  [icon]="isRecording() ? 'stop' : 'AI'"
                  [label]="(isTranscribing() ? 'ai.transcribing' : isRecording() ? 'ai.dictate-stop' : 'ai.dictate') | translate"
                  [severity]="isRecording() ? 'danger' : 'secondary'"
                  [variant]="isRecording() ? undefined : 'outlined'"/>
    <elcia-button (onClick)="send()"
                  [disabled]="isBusy()"
                  [icon]="'send'"
                  [label]="'action.send' | translate"/>
  </div>
</div>
